export const CHANNEL_JOURNEY_APPLY_N = 'apply-n';
export const CHANNEL_LOAN_APP = 'loan_app';
export const CHANNEL_MOBILE_WALLET = 'Mobile-Wallet';
export const CHANNEL_PAY_LATER = 'pay_later';
